import React from "react";

import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import styles from "./SyncOptions.module.scss";

interface Props {
  active: boolean;
  icon: IconProp;
  name: string;
  onClick: () => void;
}

const DirectionCard: React.FC<Props> = ({ active, icon, name, onClick }) => {
  return (
    <div
      className={cn(styles.directionCard, { [styles.directionCardActive]: active })}
      onClick={onClick}
    >
      <FontAwesomeIcon className={styles.icon} icon={icon} size="4x" />
      <p>{name}</p>
    </div>
  );
};

export default DirectionCard;
